import { ProjectProgress } from '@shared/models/ProjectProgress';
import { ProjectProgressListParams, PaginatedResponse, CreateProjectProgressRequest, UpdateProjectProgressRequest, ReviewProgressRequest } from '../types/api';
import { get, post, put, patch, del } from './api';

/**
 * 项目进展服务
 */
export class ProjectProgressService {
  /**
   * 获取项目进展列表（H5端使用公开接口）
   */
  static async getProjectProgresses(params?: ProjectProgressListParams): Promise<PaginatedResponse<ProjectProgress>> {
    return get<PaginatedResponse<ProjectProgress>>('/public/projectProgresses', params);
  }

  /**
   * 获取项目进展详情
   */
  static async getProjectProgressById(id: string): Promise<ProjectProgress> {
    return get<ProjectProgress>(`/projectProgresses/${id}`);
  }

  /**
   * 创建项目进展
   */
  static async createProjectProgress(data: CreateProjectProgressRequest): Promise<ProjectProgress> {
    return post<ProjectProgress>('/projectProgresses', {
      ...data,
      reviewStatus: 'PENDING',
      createTime: new Date().toISOString(),
      updateTime: new Date().toISOString(),
    });
  }

  /**
   * 更新项目进展
   */
  static async updateProjectProgress(id: string, data: UpdateProjectProgressRequest): Promise<ProjectProgress> {
    return put<ProjectProgress>(`/projectProgresses/${id}`, {
      ...data,
      updateTime: new Date().toISOString(),
    });
  }

  /**
   * 删除项目进展
   */
  static async deleteProjectProgress(id: string): Promise<void> {
    return del<void>(`/projectProgresses/${id}`);
  }

  /**
   * 审核项目进展（仅公募机构）
   */
  static async reviewProgress(id: string, reviewData: ReviewProgressRequest): Promise<ProjectProgress> {
    const reviewStatus = reviewData.result === 'APPROVED' ? 'APPROVED' : 'REJECTED';
    return patch<ProjectProgress>(`/projectProgresses/${id}`, {
      reviewStatus,
      reviewComment: reviewData.comment,
      reviewTime: new Date().toISOString(),
    });
  }
}

